import { createTypedEnum } from '@reckon-web/formschema-enums';

export const TemplateTaskJobUserTypeEnum = createTypedEnum({
  Parter: 'Parter',
  Manager: 'Manager',
  Staff: 'Staff',
  Assignee: 'Assignee',
} as const);
export type TemplateTaskJobUserTypeValues =
  (typeof TemplateTaskJobUserTypeEnum.values)[number];
export type TemplateTaskJobUserTypeLabels =
  (typeof TemplateTaskJobUserTypeEnum.labels)[number];
